import { apiInstance } from "../config/api";

export const profilerService = {
  async getMe(token?: string) {
    const response = await apiInstance.get("/profiler-account/me", token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : undefined);

    return response.data;
  },

  async getProfilerById(id: string) {
    const response = await apiInstance.get(`/profiler-account/${id}`);
    return response.data;
  },

  async updateMySellerProfile(payload: {
    shopName?: string;
    storeAddress?: string;
    note?: string;
    profilePicture?: string;
  }) {
    const response = await apiInstance.patch("/profiler-account/me/seller", payload);
    return response.data;
  },
};